import REact, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom'

const InnerContent = () => {

    const location = useLocation()

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }, [location?.pathname])

    return (
        <section>
            <div className="mt-5">
                <div className="container-xxl container-fluid">
                    <Outlet />
                </div>
            </div>
        </section>
    )

}

export default InnerContent;
